module.exports = __webpack_public_path__ + "img/img-aml@3x.f8802027.png";